import React, { Component, PureComponent } from 'react'
import { Route, Redirect, Switch } from 'react-router'
import { Map, List, fromJS } from 'immutable'
import { Button, Header, Grid, Segment, Loader, Icon, Table, Label, Checkbox } from 'semantic-ui-react'
import { generate as genId } from 'shortid'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { SubeditorListItem } from '~/common/subeditor'
import Interview from './interview'
import Products from './products'
import People from './people'
import ProjectTasks from './projectTasks'
import Helmet from 'react-helmet'
import { statusList, statusColor } from '~/interview/status'
import ContactCardList from '~/contact/views/cardList'

function ProjectProductEditor(props) {
  let { project = Map(), saving, location, match, history } = props

  /* Interview */
  let interviews = project.get('interviews', List())

  /* Products */
  let products = project.get('products', List())
  let takenProducts = interviews.reduce(
    (ids, interview) => ids.concat(interview.getIn(['data', 'products'], List())),
    List()
  )
  let productsById = products.reduce((mapped, product) => mapped.set(product.get('id'), product), Map())
  let allTaken = products.size > 0 && takenProducts.size === products.size

  /* People */
  let people = project.get('people', List())
  let peopleStatus = 'success'
  let peopleInfo = ''

  if (!people.size) {
    peopleStatus = 'warning'
    peopleInfo = 'Haastateltavien tiedot puuttuu'
  }

  /* Tasks */
  let tasks = interviews.reduce(
    (tasks, interview) => tasks.concat(interview.get('tasks', List())),
    project.get('tasks', List())
  )
  let doneTasks = tasks.filter(i => i.get('status') === 'completed')
  let tasksStatus = 'info'

  let { mainTasks, interviewTasks } = tasks.reduce(
    (info, i) => {
      if (i.get('interview_id')) {
        info.interviewTasks = info.interviewTasks + 1
      } else {
        info.mainTasks = info.mainTasks + 1
      }

      return info
    },
    { mainTasks: 0, interviewTasks: 0 }
  )

  let tasksInfo = `${mainTasks} ${mainTasks === 1 ? 'päätehtävä' : 'päätehtävää'}, ${interviewTasks} ${
    interviewTasks === 1 ? 'haastattelutehtävä' : 'haastattelutehtävää'
  }`

  return (
    <div className="subeditor">
      <Helmet title={`Projekti ${project.get('name')}`} />
      <div className="subeditor-list">
        <div className="subeditor-list-scroll">
          <SubeditorListItem
            title={`Kaikki tehtävät`}
            info={tasksInfo}
            status={tasksStatus}
            tag={`${doneTasks.size} / ${tasks.size}`}
            tagIcon="check"
            tagColor={tasks.size && doneTasks.size === tasks.size ? 'green' : 'grey'}
            exact
            to={`${match.url}`}
          />
          <SubeditorListItem
            title={`Tuotteet (${products.size})`}
            info={allTaken ? 'Kaikki käsitelty' : `${products.size - takenProducts.size} käsittelemättä`}
            status={allTaken ? 'success' : 'warning'}
            tag={allTaken ? false : 'Käsittele'}
            tagColor={allTaken ? 'grey' : 'yellow'}
            tagIcon={allTaken ? false : 'warning sign'}
            to={`${match.url}/products`}
          />
          <SubeditorListItem
            title={`Haastateltavat (${people.size})`}
            info={peopleInfo}
            status={peopleStatus}
            to={`${match.url}/people`}
          />
          <div className="subeditor-list-title">Haastattelut</div>
          {interviews
            .sort((a, b) => {
              let aValue = a.get('name')
              let bValue = b.get('name')
              return aValue > bValue ? 1 : -1
            })
            .map(i => {
              let id = i.get('id')
              let tasks = i.get('tasks', List())
              let people = i.get('people', List())
              let doneTasks = tasks.filter(i => i.get('status') === 'completed')

              let info = statusList[i.get('status')]
              let color = statusColor[i.get('status')]

              return (
                <SubeditorListItem
                  title={i.get('name')}
                  info={info}
                  status={color}
                  to={`${match.url}/interview/${id}`}
                  tag={`${doneTasks.size} / ${tasks.size}`}
                  tagIcon="check"
                  tagColor={tasks.size && doneTasks.size === tasks.size ? 'green' : 'grey'}
                  key={id}
                />
              )
            })}
          <div className="subeditor-list-title">Yhteyshenkilöt</div>
          <ContactCardList project={project} />
        </div>
      </div>
      <div className="subeditor-main">
        <Switch>
          <Route
            path={`${match.url}/products`}
            exact={true}
            component={() => (
              <Products takenProducts={takenProducts} allTaken={allTaken} products={products} interviews={interviews} />
            )}
          />
          <Route
            path={`${match.url}/people`}
            exact={true}
            component={() => <People project={project} people={people} interviews={interviews} />}
          />
          <Route
            path={`${match.url}/interview/:interview_id`}
            exact={true}
            component={() => <Interview interviews={interviews} productsById={productsById} />}
          />
          <Route component={ProjectTasks} />
        </Switch>
      </div>
    </div>
  )
}

/*
<Table>
  <Table.Header>
    <Table.Row>
      <Table.HeaderCell>
        <span className="order-editor-main-title">Haastattelut</span>
      </Table.HeaderCell>
    </Table.Row>
  </Table.Header>
  <Table.Body>
    { interviews.map(interview => {
        let id = interview.get('id')
        let open = openInterviews.contains(id)
        return (
          <Table.Row key={ id }>
            <Table.Cell className="order-editor-interview-cell">
              <Interview interview={ interview }
                open={ open }
                productsById={ productsById }
                onOpenToggle={ () => this.setState({ openInterviews: open ? openInterviews.remove(openInterviews.indexOf(id)) : openInterviews.push(id) }) }
                removeItem={ () => formUpdate({
                               name: 'interviews',
                               value: interviews.filter(i => i.get('id') !== id)
                             }) } />
            </Table.Cell>
          </Table.Row>
        )
      }) }
  </Table.Body>
</Table>
*/

function mapStateToProps(state) {
  return {
    saving: state.orderEditorSaving,
  }
}

function mapDispatchToProps(dispatch) {
  return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProjectProductEditor))
